import { request } from './client';
import type { RequestOptions } from './client';
import type { GeocodedLocation } from '@/types/types';

/**
 * Resolves a free-text address through the server-side Google Maps proxy.
 *
 * The endpoint answers with both the raw Google payload (`data.results`) and a normalised flat list
 * (`locations`). This returns the normalised list — it is the shape a stored `location` field holds,
 * so the envelope is known here instead of in every component that searches for an address.
 */
export function geocodeAddress(address: string, requestOptions: RequestOptions = {}): Promise<GeocodedLocation[]> {
  return request('POST', '/v1/account/google-maps/geo-coding', undefined, { address }, requestOptions).then(
    (response: { locations?: GeocodedLocation[] }) => response.locations ?? []
  );
}
